import { TranslateService } from '@ngx-translate/core';
import { registerI18nTranslateService } from '@eon-is/ts-utils';
import deLocal from '../../assets/i18n/de.json';
import enLocal from '../../assets/i18n/en.json';
import huLocal from '../../assets/i18n/hu.json';

export function configureTranslateService(translateService: TranslateService): void {
    registerI18nTranslateService(translateService);
    translateService.addLangs(['en', 'de', 'hu']);
    translateService.setTranslation('en', enLocal, true);
    translateService.setTranslation('de', deLocal, true);
    translateService.setTranslation('hu', huLocal, true);
    const storedLang: string | null = localStorage.getItem('language');


    if (storedLang) {
        translateService.use(storedLang);
    } else {
        const browserLang: string | undefined = translateService.getBrowserLang();

        const defaultLang: string = browserLang?.match(/en|de|hu/) ? browserLang : 'en';

        localStorage.setItem('language', defaultLang);
        translateService.use(defaultLang);
    }
}
